import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { point, point_page, point_count, backend } from '../../components/apipath';
import { switchHelper} from "../../modules/helpers";
import { ColGroup } from "../../components/ColGroup.js";

function PointRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [data, setData] = useState([]);
    const limit = 50;
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({
        name: '',
        start: '',
        end: '',
        status: '',
        e_material: '',
    });
    
    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);

    useEffect(() => {
        fetchPageData();
    }, [page]);

    const handleSearch = () => {
        setPage(1); 
        fetchPageData();
    };

    // 讀取點數申請記錄
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const params = {
                studentName: search.name || '',
                startDate: search.start || '',
                endDate: search.end || '',
                status: search.status || '',
                e_material: search.e_material !== '' ? String(search.e_material) : '',
                page: page - 1,
                rows: 50
            };
            const response = await axios.get(`${point_page(page - 1, rows)}`, {
                headers: { token },
                params
            });
            setRequestList(response.data);
            } catch (error) {
            console.error('Error fetching request list:', error);
            } finally {
            setLoading(false);
            }
        };
        
    


      const fetchPageData = async () => {
        try {
          const params = {
            studentName: search.name || '',
            startDate: search.start || '',
            endDate: search.end || '',
            status: search.status || '',
            e_material: search.e_material !== '' ? String(search.e_material) : '',
            page: page - 1,
            rows: limit
          };
      
          const [countRes, dataRes] = await Promise.all([
            axios.get(`${backend}point/count`, { headers: { token }, params }),
            axios.get(`${backend}point/p/${page - 1}/${limit}`, { headers: { token }, params }),
          ]);
      
          setRowsCount(countRes?.data?.data?.[0]?.total || 0);
          setData(dataRes?.data || []);
          setRequestList(dataRes?.data || []);
      
        } catch (err) {
          console.error('❌ 搜尋失敗:', err);
          setRowsCount(0);
          setData([]);
          setRequestList([]);
        }
      };
      
      


    
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    
    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    const formatToMysqlDatetime = (dateInput) => {
        const date = new Date(dateInput);
        const pad = (n) => (n < 10 ? '0' + n : n);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
               `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
    
        let finalValue;
    
        if (name === "e_material") {
            finalValue = parseInt(value, 10);
        } else if (type === "checkbox") {
            finalValue = switchHelper(checked);
        } else if (type === "number") {
            finalValue = value === '' ? '' : parseInt(value, 10);
        } else {
            finalValue = value;
        }
    
        setUpdatedData(prev => {
            const newData = {
                ...prev,
                [name]: finalValue
            };
    
            // 自動計算剩餘點數
            if (
                (name === 'total_points' || name === 'requested_points') &&
                newData.total_points !== undefined &&
                newData.requested_points !== undefined
            ) {
                newData.remaining_points_after = newData.total_points - newData.requested_points;
            }
    
            return newData;
        });
    };
    

    const saveChanges = async () => {
        try {
            const remaining = updatedData.total_points - updatedData.requested_points;
    
            const dataToSend = {
                ...updatedData,
                remaining_points_after: remaining,
            };
    
            console.log("✅ 更新送出的資料:", dataToSend);
    
            const response = await axios.put(`${point}`, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                }
            });
    
            setRequestList(prevList =>
                prevList.map(req =>
                    req.id === updatedData.id ? response.data : req
                )
            );
            await fetchData();
            setEditingRequest(null);
        } catch (error) {
            console.error("更新失敗:", error);
        }
    };
    
    

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    // 用法
    const formattedDate = formatDate("2025-02-11T00:00:00.000Z");
    console.log(formattedDate); // 2025-02-11

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        
        setUpdatedData(prevData => {
            const currentSubjects = prevData.core_subject ? prevData.core_subject.split(',') : [];
            let updatedSubjects;
            
            if (checked) {
                // 如果選中，新增該學科
                updatedSubjects = [...currentSubjects, value];
            } else {
                // 如果取消選中，移除該學科
                updatedSubjects = currentSubjects.filter(subject => subject !== value);
            }
    
            return {
                ...prevData,
                core_subject: updatedSubjects.join(',')  // 將陣列轉為逗號分隔的字串
            };
        });
    };
    // const formatDate = (dateString) => {
    //     if (!dateString) return "";
    //     const date = new Date(dateString);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const day = String(date.getDate()).padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // };
    
    const colWeights = [1,1,1,1,1,1,1,4,1];
    
    return (
        <>
            <div className="mt100 container-fluid">
                {loading ? (
                    <p>載入中...</p>
                ) : (
                    <div className="mt-2">
                        <div className="row mb-3">
                            <div className="col-md-2 mb-2">
                                <input
                                type="text"
                                className="form-control"
                                placeholder="學生姓名"
                                value={search.name}
                                onChange={(e) => setSearch({ ...search, name: e.target.value })}
                                />
                            </div>

                            <div className="col-md-2 mb-2">
                                <select
                                className="form-control"
                                value={search.status}
                                onChange={(e) => setSearch({ ...search, status: e.target.value })}
                                >
                                <option value="">全部狀態</option>
                                <option value="審核中">審核中</option>
                                <option value="完成">完成</option>
                                <option value="取消">取消</option>
                                </select>
                            </div>

                            <div className="col-md-2 mb-2">
                                <select
                                className="form-control"
                                value={search.e_material}
                                onChange={(e) => setSearch({ ...search, e_material: e.target.value })}
                                >
                                <option value="">電子講義</option>
                                <option value="true">已領</option>
                                <option value="false">未領</option>
                                </select>
                            </div>
                            <div className="col-md-2 mb-2">
                                <input
                                type="date"
                                className="form-control"
                                value={search.start}
                                onChange={(e) => setSearch({ ...search, start: e.target.value })}
                                />
                            </div>

                            <div className="col-md-2 mb-2">
                                <input
                                type="date"
                                className="form-control"
                                value={search.end}
                                onChange={(e) => setSearch({ ...search, end: e.target.value })}
                                />
                            </div>

                            

                            <div className="col-md-2 mb-2">
                                <button className="btn btn-primary w-100" onClick={handleSearch}>
                                搜尋
                                </button>
                            </div>
                        </div>

                        <table className="table table-striped border table-fixed w-100">
                            <ColGroup weights={colWeights} />
                            <thead>
                                <tr>
                                    <th>學生姓名</th>
                                    <th>學科</th>
                                    <th>電子講義</th>
                                    <th>申請點數</th>
                                    {/* <th>剩餘點數</th> */}
                                    <th>總點數</th>
                                    <th>申請狀態</th>
                                    <th>申請日期</th>
                                    <th>備註</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                            {requestList.map((request) => (
                                <tr key={request.id}>
                                    {editingRequest && editingRequest.id === request.id ? (
                                        <>
                                            <td colSpan={8}>
                                                <div className="container-fluid">
                                                    <div className="row g-1">
                                                        <div className="col-md-2">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">學生姓名</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="student_name"
                                                                    value={updatedData.student_name}
                                                                    onChange={handleInputChange}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>   
                                                        <div className="col-md-10">
                                                            <div className="d-flex flex-wrap align-items-center">
                                                                <label className="form-label me-3">學科</label>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectFAR"
                                                                        value="FAR"
                                                                        checked={updatedData.core_subject?.includes("FAR")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectFAR">FAR</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectREG"
                                                                        value="REG"
                                                                        checked={updatedData.core_subject?.includes("REG")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectREG">REG</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectAUD"
                                                                        value="AUD"
                                                                        checked={updatedData.core_subject?.includes("AUD")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectAUD">AUD</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectBAR"
                                                                        value="BAR"
                                                                        checked={updatedData.core_subject?.includes("BAR")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">BAR</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectISC"
                                                                        value="ISC"
                                                                        checked={updatedData.core_subject?.includes("ISC")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">ISC</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectTCP"
                                                                        value="TCP"
                                                                        checked={updatedData.core_subject?.includes("TCP")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectTCP">TCP</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectEA-P1"
                                                                        value="EA-Part1"
                                                                        checked={updatedData.core_subject?.includes("EA-Part1")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectEA-P1">EA-Part1</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectEA-P2"
                                                                        value="EA-Part2"
                                                                        checked={updatedData.core_subject?.includes("EA-Part2")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectEA-P2">EA-Part2</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectEA-P3"
                                                                        value="EA-Part3"
                                                                        checked={updatedData.core_subject?.includes("EA-Part3")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectEA-P3">EA-Part3</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectCMA-P1"
                                                                        value="CMA-P1"
                                                                        checked={updatedData.core_subject?.includes("CMA-P1")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectCMA-P1">CMA-Part1</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="subjectCMA-P2"
                                                                        value="CMA-P2"
                                                                        checked={updatedData.core_subject?.includes("CMA-P2")}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="subjectCMA-P2">CMA-Part2</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請點數</span>
                                                                <input
                                                                className="form-control"
                                                                type="text"
                                                                name="requested_points"
                                                                value={updatedData.requested_points || ''}
                                                                onChange={handleInputChange}
                                                                pattern="[0-9]*"
                                                                inputMode="numeric"
                                                                required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">總點數</span>
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    name="total_points"
                                                                    value={updatedData.total_points || ''}
                                                                    onChange={handleInputChange}
                                                                    min="0"
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">電子講義</span>
                                                                <select
                                                                className="form-select"
                                                                name="e_material"
                                                                value={String(updatedData.e_material)}
                                                                onChange={handleInputChange}
                                                                >
                                                                <option value="1">已領</option>
                                                                <option value="0">未領</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="input-group input-group-sm">
                                                            <span className="input-group-text">備註</span>
                                                            <textarea
                                                                className="form-control"
                                                                rows={3}
                                                                name="remarks"
                                                                value={updatedData.remarks ?? ''}
                                                                onChange={handleInputChange}
                                                                placeholder="內部備註（不顯示給學生）"
                                                            />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td> <a
                                                    href={`/adm/admmemberedit/${request.mem_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {request.student_name}
                                                </a>
                                            </td>
                                            <td>{request.core_subject}</td>
                                            <td>{request.e_material === 1 ? "已領" : "未領"}</td>
                                            {/* <td>{request.remaining_points_after|| "未審核完成"}</td> */}
                                            <td>{request.requested_points ?? ""}</td>
                                            <td>{request.total_points ?? "未給予總點數"}</td>
                                            <td>{request.status}</td>
                                            <td>{formatDate(request.timestamp)}</td>
                                            <td>{request.remarks}</td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>

                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                        </table>
                        <div className="mt-3 text-center">
                            <button
                                className="btn btn-outline-secondary me-2"
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            >
                                上一頁
                            </button>
                            <span>第 {page} 頁 / 共 {Math.ceil(rowsCount / limit)} 頁</span>
                            <button
                                className="btn btn-outline-secondary ms-2"
                                disabled={page >= Math.ceil(rowsCount / limit)}
                                onClick={() => setPage(page + 1)}
                            >
                                下一頁
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default PointRequest;
